﻿$.fn.extend({
    animateCss: function (animationName, callback) {
        var animationEnd = (function (el) {
            var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd',
            };

            for (var t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        })(document.createElement('div'));

        this.addClass('animated ' + animationName).one(animationEnd, function () {
            $(this).removeClass('animated ' + animationName);

            if (typeof callback === 'function') callback();
        });

        return this;
    },
});

$(function () {
    let notificationDismissed = false; // Track if the user already click to dismiss the notifications

    $("#notification-bar .action-dismiss").click(function (event) {
        // Don't allow this to be fired multiple times
        if (notificationDismissed) {
            return;
        }

        var $currentTarget = $(event.currentTarget);
        var notificationId = $currentTarget.data('notification-id');

        notificationDismissed = true;

        $.post('/account/dismissnotification?notificationId=' + notificationId.toString())
            .done(function () {
                $currentTarget.parents("#notification-bar").fadeOut();
            });

        
    });
});

$.fn.progressRing = function () {
    this.each((idx, elem) => {
        const $elem = $(elem);
        const pct = $elem.data('progress-percent');
        const val = $elem.data('progress-value');
        const color = $elem.data('progress-color');
        const className = $elem.data('progress-class');
        const height = $elem.height();
        const halfHeight = height / 2;
        const strokeWidth = 3;
        const radius = halfHeight - (strokeWidth * 2);

        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");

        const $circle = $(circle);

        $circle.attr({
            'class': `progress-ring-circle`,
            'stroke' : color,
            'stroke-width' : strokeWidth,
            'fill': 'transparent',
            'r': radius,
            'cx' : halfHeight,
            'cy' : halfHeight
        });

        const baseCircle = $circle[0].cloneNode();
        $elem[0].appendChild(baseCircle);

        const circumference = radius * 2 * Math.PI;
        circle.style.strokeDasharray = `${circumference} ${circumference}`;

        // Ensure that every circle starts off at 10% so it at least shows 
        // in the UI.We compress the actual percentage by 10 % so we can 
        // start off at 10 % and that the passed in percentage scales correctly.
        const adjustedPct = (pct * .9) + 10;

        const offset = circumference - adjustedPct / 100 * circumference;
        circle.style.strokeDashoffset = offset;
        circle.setAttribute('class', 'progress-ring-circle ' + className);

        $elem[0].appendChild($circle[0]);
        

        // If there is a value to display, do it.
        if (val != null && val != '') {
            const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
            const $text = $(text);

            $text.attr({
                'x': '50%',
                'y': '50%',
                'text-anchor': 'middle',
                'dy': '.3em',
                'font-size': '0.7em',

            });

            $text[0].textContent = val;

            $elem[0].appendChild($text[0]);
        }
    });
}

/*
* Function that tracks a click on an outbound link in Analytics.
* This function takes a valid URL string as an argument, and uses that URL string
* as the event label. Setting the transport method to 'beacon' lets the hit be sent
* using 'navigator.sendBeacon' in browser that support it.
*/
window.trackEvent = function (event_name, event_category, event_label, extraParams) {
    $(function () {
        if (typeof gtag !== 'undefined') {
            var eventParams = {
                'event_category': event_category,
                'event_label': event_label
            };

            eventParams = Object.assign(eventParams, extraParams || {});

            gtag('event', event_name, eventParams);
        }

        if (typeof window.clarity !== 'undefined') {
            window.clarity("event", event_name);
        }
        /*
        window.LOQ = window.LOQ || [];
        window.LOQ.push(['ready', async LO => {
            await LO.$internal.ready('events');
            LO.events.track(event_name);
        }]);
        */
    });
}

window.VoterFly = window.VoterFly || {};